// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exit_seat_class[data-v-08301856]{position:relative}.exit_seat_class[data-v-08301856]:after{content:\"\";position:absolute;bottom:-.9px;left:0;right:0;width:100%;height:6px;background-color:#ef5350;border-bottom-left-radius:8px;border-bottom-right-radius:8px}", ""]);
// Exports
module.exports = exports;
